// extracted by mini-css-extract-plugin
export default {"popup__title":"mediaDevicesErrorPopup_popup__title__3bg7R","popup__img":"mediaDevicesErrorPopup_popup__img__GsCIN","popup__text":"mediaDevicesErrorPopup_popup__text__k-1zU"};